import { render, staticRenderFns } from "./WaybillItemsEdit.vue?vue&type=template&id=34a23c89&scoped=true&"
import script from "./WaybillItemsEdit.vue?vue&type=script&lang=js&"
export * from "./WaybillItemsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a23c89",
  null
  
)

export default component.exports